import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface FolderNameDialogData {
  title: string;
  action: string;
  name?: string;
}

/**
 * asks for the name of a Sammelmappe (create, rename, duplicate) and closes with the trimmed name
 */
@Component({
  selector: 'app-folder-name-dialog',
  templateUrl: './folder-name-dialog.component.html',
  styleUrls: ['./folder-name-dialog.component.scss'],
  standalone: false
})
export class FolderNameDialogComponent {

  readonly maxLength = 256;
  nameCtrl: FormControl<string>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: FolderNameDialogData,
              private dialogRef: MatDialogRef<FolderNameDialogComponent, string>) {
    this.nameCtrl = new FormControl(data?.name ?? '', [Validators.required, Validators.maxLength(this.maxLength)]);
  }

  submit(): void {
    const name = this.nameCtrl.value?.trim();
    if (this.nameCtrl.invalid || !name) {
      this.nameCtrl.markAsTouched();
      return;
    }
    this.dialogRef.close(name);
  }
}
